//全局公共方法
const getParams = (params = {}) => {
  // 用&连接参数
  let result = "";
  const keys = Object.keys(params);
  for (const key of keys) {
    const flag = keys.indexOf(key) !== 0;
    result += (flag ? "&" : "") + key + "=" + encodeURIComponent(params[key] || "");
  }
  return result;
};

const getformParams = (inParams = {}) => {
  const formData = new FormData();
  const keys = Object.keys(inParams);
  for (const key of keys) {
    formData.append(key, inParams[key] || '');
  }
  return formData;
};

function judgeJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

//XHR请求方法
export function handleRequest(url, config, callback) {
  const { params, method, data, isJson = false } = config;
  const xhr = new XMLHttpRequest();
  const query = getParams(params);
  // const exportUrl = process.env.VUE_APP_BASE_API + url + (query ? "?" : "") + query;
  const exportUrl = url + (query ? "?" : "") + query;
  xhr.open(method, exportUrl);
  // xhr.setRequestHeader("Authorization", `Bearer ${getToken()}`);
  if (isJson) xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onload = function (e) {
    // console.log('response:', JSON.parse(this.response));
    if (this.status === 200) {
      if (judgeJson(this.response) && callback) callback("success", JSON.parse(this.response));
      else if (callback) callback("success", { message: 'Success' });
    } else if (this.status === 500) {
      if (callback) callback("fail", { message: "Internal Server Error" });
    } else {
      if (judgeJson(this.response) && callback) callback("fail", JSON.parse(this.response));
    }
  };

  if (method === "post") {
    const requestParams = isJson ? JSON.stringify(data) : getformParams(data);
    xhr.send(requestParams);
  } else xhr.send();
}

//神策埋点方法
export function sensorsRecord(params, type = 2) {
  //type: $pageview - 1-浏览，$WebClick - 2-点击(默认)，$WebStay - 3-页面停留
  const { key, target } = params;
  if (!key) return;
  const typeObj = {
    1: '$pageview',
    2: '$WebClick',
    3: '$WebStay'
  };
  const myIndex = key.indexOf('_');
  const model_name = key.slice(0, myIndex);//机型
  const operation_key = key.slice(myIndex + 1);//操作码
  const sensors = window['sensorsDataAnalytic201505'];
  // const service_name = 'web_phomemo';
  const service_name = 'web_support';//2025-4-30变更为新的固定属性值web_support
  const inParams = {
    service_name,
    model_name,
    operation_key,
  };
  if (type == 1) {//浏览
    if (sensors && sensors.quick) sensors.quick("autoTrackSinglePage", inParams);
  }
  if (type == 2) {//点击
    //如果需要添加自定义属性需要将 SDK 升级到 1.13.7 及以上版本。
    const inTarget = target || document.getElementById("app");//由于点击埋点必须传入节点，补充获取缺省节点#app
    if (sensors && sensors.quick) sensors.quick('trackAllHeatMap', inTarget, inParams);
  }
  if (type === 3) {
    //页面停留-注意：页面停留不能主动触发，此处只是为了设置页面公共配置而触发的操作，为了实现停留事件上报时携带自定义参数，并不是触发埋点上报
    sensors.registerPage({
      service_name,
      model_name,
      operation_key: 'WebStay',
    });
  }
  // console.log('sensorsRecord:', params, ' type:', type);
  // console.log('inParams:', inParams, typeObj[type]);
}

//埋点方法
export function refreshRecord(params) {
  const origin = 'https://www.aimocloud.com/api-v1.0';//正式环境
  // const origin = 'http://10.168.2.19:31688';//测试环境
  // const origin = 'https://10.168.3.184/test';

  const url = origin + '/other/api/v1/data/burialPoint/addBurialPointRecords';
  const { key } = params;
  const myParams = {
    key: key,
  };//key含义详见：https://www.tapd.cn/54786155/prong/stories/view/1154786155001000384
  handleRequest(
    url,
    {
      method: "post",
      data: myParams,
      isJson: false,
      params: {},
    },
    (status, response) => {
      // console.log('myParams:', myParams);
      // console.log('response:', status, response);
      // if (status === 'success') {
      // } else if (status === 'fail') {
      // }
    }
  );
  sensorsRecord(params, 2);
}


export const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};


// WEBPACK FOOTER //
// ./src/util.js